import React from 'react';
import Flagship from '../../core/flagship';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import LineItemAddModal from '../modals/LineItemAddModal';
import LineItemPricingModal from '../modals/LineItemPricingModal';
import LineItemViewModal from '../modals/LineItemViewModal';
import LineItemEditModal from '../modals/LineItemEditModal';
import {getFormattedValue, empty} from '../../utils/helpers';
import { Divider, Header, Loader, Card, Button, Icon, Label} from 'semantic-ui-react';

class LineItemBox extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.getLineItems = this.getLineItems.bind(this);
        this.onAddNew = this.onAddNew.bind(this);
        this.cancelAddNew = this.cancelAddNew.bind(this);
        this.closeModals = this.closeModals.bind(this);
        this.renderLineItems = this.renderLineItems.bind(this);
        this.onLineItemAddModalChange = this.onLineItemAddModalChange.bind(this);
        this.onLineItemPricingModalChange = this.onLineItemPricingModalChange.bind(this);
        this.onUpdatePricing = this.onUpdatePricing.bind(this);
        this.onViewLineItem = this.onViewLineItem.bind(this);
        this.onEditLineItem = this.onEditLineItem.bind(this);
        this.onAddLineItem = this.onAddLineItem.bind(this);
        this.onUpdateLineItem = this.onUpdateLineItem.bind(this);
        this.swapToEdit = this.swapToEdit.bind(this);
        this.swapToView = this.swapToView.bind(this);
        this.renderAddLineItemModal = this.renderAddLineItemModal.bind(this);
        this.renderPrice = this.renderPrice.bind(this);
        this.maybeOpenLineItem = this.maybeOpenLineItem.bind(this);
    }

    getInitialState() {
        return {
            loading:true,
            lineItems: [],
            newLineItemName: '',
            newLineItemService: null,
            newLineItemServiceNiceName: null,
            editPricingFields: [],
            addingLineItem: false,
            viewingLineItem: false,
            editingLineItem: false,
            updatingPricing: false,
            newLineItemData: [],
            editing: {},
        }
    }

    componentDidMount() {
        this.getLineItems();
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.viewingChild !== this.props.viewingChild) {
            this.maybeOpenLineItem(nextProps);
        } else {
            if (nextProps !== this.props) {
                this.getLineItems();
            }
        }
    }

    maybeOpenLineItem(nextProps = false) {

        let propsToConsider = nextProps === false ? this.props : nextProps;
        let self = this;
        let viewingNow = false;

        this.state.lineItems.map(function(item) {

            if (item.line_item_key === propsToConsider.viewingChild) {
                viewingNow = true;
                self.setState({
                    viewingLineItem: item
                });
            }
        });
        if (viewingNow !== true ) {
            this.setState({
                viewingLineItem: false
            });
        }
    }


    getLineItems() {
        let self = this;
        Flagship.get(
            'line-items/' + this.props.recordId,
            {},
            function (response) {
                if (response.data.success === true) {
                    self.setState({
                        lineItems: response.data.results,
                        loading:false
                    }, function() {

                        if (self.state.lineItems.length) {

                            self.props.hasLineItems(true);

                            // See if line items are priced and open view of line item if specified in component props
                            let allLineItemsPriced = true;
                            self.state.lineItems.map(function (item) {
                                if (item.price === null || item.price === "") {
                                    allLineItemsPriced = false;
                                }

                                if (item.line_item_key === self.props.viewingChild) {
                                    self.setState({
                                        viewingLineItem: item
                                    });
                                }
                            });
                            if (self.props.recordStatus === "publish" && allLineItemsPriced === true) {
                                // Pricing complete
                                Flagship.changeRecordStatus(self.props.recordId, "priced", self.props.onStatusChange);

                            } else if (self.props.recordStatus !== "publish" &&
                                self.props.recordStatus !== "draft" &&
                                self.props.recordStatus !== "trash" &&
                                allLineItemsPriced === false) {
                                // More pricing to do
                                Flagship.changeRecordStatus(self.props.recordId, "publish", self.props.onStatusChange);
                            }
                        } else {
                            self.props.hasLineItems(false);
                        }
                    });

                } else {

                    Flagship.error(
                        "Error getting line items from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {

                Flagship.error(
                    "Error getting line items from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );
    }

    onUpdatePricing(e, data, item) {
        this.setState({
            updatingPricing: item
        });
    }

    onViewLineItem(e, data, item) {
        this.setState({
            viewingLineItem: item
        });
    }

    onEditLineItem(e, data, item) {

        this.setState({
            editingLineItem: item
        });
    }

    swapToEdit() {
        let item = this.state.viewingLineItem;
        let self = this;

        this.setState({
            viewingLineItem: false,
        }, function() {
            self.setState({
                editingLineItem: item
            });
        });
    }

    swapToView() {
        let item = this.state.editingLineItem;
        let self = this;

        this.setState({
            editingLineItem: false
        },function() {
            self.setState({
                viewingLineItem: item
            });
        });
    }

    onAddNew() {
        this.setState({
            addingLineItem: true
        });
    }

    cancelAddNew() {
        this.setState({
           newLineItemService: null,
           newLineItemServiceNiceName: '',
           addingLineItem: false
        });
    }


    closeModals() {
        this.setState({
            updatingPricing: false,
            viewingLineItem: false,
            editingLineItem: false
        }, this.props.onCloseModals);
    }


    onLineItemAddModalChange(lineItemData) {
        this.setState({
            newLineItemData: lineItemData
        });
    }

    onLineItemPricingModalChange(newPricing) {
        this.setState({
           editPricingFields: newPricing
        });
    }

    onAddLineItem() {
        this.getLineItems();
        this.setState({
            addingLineItem: false
        });
        if (typeof this.props.onAddLineItem === "function") {
            this.props.onAddLineItem();
        }
    }

    onUpdateLineItem() {
        this.setState({
            editingLineItem: false
        });
    }

    updateLineItemPricing(e) {
        let self = this;
        e.persist();
        Flagship.post(
            "line-item/update-pricing/" + self.state.updatingPricing.id,
            self.state.editPricingFields,
            function(response) {
                if (response.data.success === true) {
                    Flagship.event("update-line-item-pricing", {
                        lineItemId: self.state.updatingPricing.id,
                        lineItemKey: self.state.updatingPricing.line_item_key,
                        lineItemName: self.state.updatingPricing.line_item_name,
                        pricingFields: self.state.editPricingFields,
                    }, self.props.recordId, self.props.userId);
                    Flagship.notify("Pricing info updated.");
                    self.setState({
                        updatingPricing: false,
                        editingLineItem: false
                    }, function() {
                        self.getLineItems();
                    });
                } else {
                    Flagship.error("Error updating pricing info.", self.props.recordId, self.props.userId);
                }
            }, function(err) {
                Flagship.error("Error updating pricing info: " + err, self.props.recordId, self.props.userId);
            }
        );
    }

    renderPrice(item) {

        let onUpdatePricing = this.onUpdatePricing.bind(this);

        if (item.price !== "" && item.price !== null) {
            return (
                <div>
                    <Label
                        onClick={(e, data) => {onUpdatePricing(e, data, item)}}
                        className="pointer hover-dark-blue"
                        color="blue">{getFormattedValue(item.price,'money')}</Label>

                    {item.cogs !== "" && item.cogs !== null ?
                        <Label
                            className="pointer hover-dark-gray"
                            onClick={(e, data) => {onUpdatePricing(e, data, item)}}>{getFormattedValue(item.cogs,'money')} COGS</Label>
                        : null
                    }
                </div>
            );
        } else {
            if (this.props.userRole === "proposal_strategist" || this.props.userRole === "admin") {
                return (
                    <Label
                        onClick={(e, data) => {onUpdatePricing(e, data, item)}}
                        color="green"
                        className="pointer hover-dark-green"
                        content="Needs Pricing" />
                );
            }
            // Default (Can't Edit Price)
            return (
                <Label color="green">Needs Pricing</Label>
            );
        }
    }

    renderLineItems() {

        if ( typeof this.state.lineItems === "object" && this.state.lineItems.length === 0 ) {
            return (
                <div>No line items found.</div>
            );
        }

        let onEditLineItem = this.onEditLineItem;
        let renderPrice = this.renderPrice;
        let currentRfpKey = this.props.recordKey;

        return (
            <Card.Group>
                {this.state.lineItems.map(function(item, i) {

                   return (
                      <Card key={"line-item-" + i} className="single-line-item">
                          <Card.Content>
                              <Icon color="grey" circular className="float-right" name="pin" />
                              <Card.Header>
                              <Header as="h4">{item.line_item_name}</Header>
                              </Card.Header>
                              {item.line_item_key !== "" ? <Card.Meta>{item.line_item_key}</Card.Meta> : null}
                              <Card.Description>
                                  {renderPrice(item)}
                              </Card.Description>
                              <Card.Content extra>
                                  <br/>
                                  <div className="ui two buttons line-item-actions">
                                      <Link to={"/rfp/view/" + currentRfpKey + '/focus/' + item.line_item_key}><Button basic primary>View</Button></Link>
                                      <Button basic secondary onClick={(e, data) => {onEditLineItem(e, data, item)}}>Edit</Button>
                                  </div>
                              </Card.Content>
                          </Card.Content>
                      </Card>
                   ) ;
                })}
            </Card.Group>
        );
    }

    renderUpdatePricingModal() {
        if (this.state.updatingPricing === false) {
            return null;
        } else {
            return (
                <LineItemPricingModal
                    open={true}
                    cancelUpdate={this.closeModals.bind(this)}
                    updateLineItemPricing={this.updateLineItemPricing.bind(this)}
                    lineItemId={!empty(this.state.updatingPricing.id) ? this.state.updatingPricing.id : false }
                    recordId={this.props.recordId}
                    onChange={this.onLineItemPricingModalChange}
                    lineItem={this.state.updatingPricing}
                />
            );
        }
    }

    renderViewLineItemModal() {
        if (this.state.viewingLineItem === false) {
            return null;
        } else {
            return (
                <LineItemViewModal
                    open={true}
                    cancelUpdate={this.closeModals.bind(this)}
                    lineItemId={!empty(this.state.viewingLineItem.id) ? this.state.viewingLineItem.id : false }
                    recordId={this.props.recordId}
                    lineItem={this.state.viewingLineItem}
                    swapToEdit={this.swapToEdit}
                    getLineItems={this.getLineItems}
                />
            );
        }
    }


    renderEditLineItemModal() {
        if (this.state.editingLineItem === false) {
            return null;
        } else {
            return (
                <LineItemEditModal
                    open={true}
                    cancelUpdate={this.closeModals.bind(this)}
                    lineItemId={!empty(this.state.editingLineItem.id) ? this.state.editingLineItem.id : false }
                    recordId={this.props.recordId}
                    lineItem={this.state.editingLineItem}
                    swapToView={this.swapToView}
                    onChange={this.onLineItemEditModalChange}
                    onUpdateLineItem={this.onUpdateLineItem}
                />
            );
        }
    }


    renderAddLineItemModal() {
        if (this.state.addingLineItem === false) {
            return null;
        } else {
            return (
                <LineItemAddModal
                    open={true}
                    cancelAddNew={this.cancelAddNew.bind(this)}
                    recordId={this.props.recordId}
                    onChange={this.onLineItemAddModalChange}
                    name={this.state.newLineItemName}
                    service={this.state.newLineItemService}
                    serviceNiceName={this.state.newLineItemServiceNiceName}
                    newLineItemService={this.state.newLineItemService}
                    onAddLineItem={this.onAddLineItem}
                />
            );
        }
    }


    render() {

        return (
            <div className="line-item-box">
                <Divider hidden />
                <Header as="h3">Line Items</Header>
                {
                    this.state.loading === true ?
                        <Loader color="blue" className="flagship-loader" active inline='centered' />
                        :
                        <div>
                            {this.renderLineItems()}
                            <br />
                            {this.props.recordStatus === "draft" ||
                            this.props.recordStatus === "publish" ||
                            this.props.recordStatus === "priced" ?
                                <div className="pulsing-button-wrap">
                                    <Button
                                        primary
                                        icon="plus"
                                        content={ this.state.lineItems.length ? "Add Another Line Item..." : "Add a Line Item..."}
                                        onClick={this.onAddNew}
                                        className={this.state.lineItems.length ? "pulsing-button-normal" : "pulsing-button-pulsing"}
                                    />
                                </div>
                                :
                                <div className="gray-text">You cannot add any more line items to this RFP.</div>
                            }
                        </div>
                }
                {this.renderAddLineItemModal()}
                {this.renderUpdatePricingModal()}
                {this.renderViewLineItemModal()}
                {this.renderEditLineItemModal()}


            </div>
        );
    }
}

LineItemBox.propTypes = {
    actions: PropTypes.object,
    username: PropTypes.string,
    userId: PropTypes.number,
    userRole: PropTypes.string,
};

function mapStateToProps(state) {
  return {
      username: state.main.username,
      userId: state.main.userId,
      userRole: state.main.userRole
  };
}

export default connect(
  mapStateToProps
)(LineItemBox);





// WEBPACK FOOTER //
// ./src/components/records/LineItemBox.js